import React from 'react';
import { FormattedText } from 'core/i18n';
import CustomScrollBar from 'components/customScrollBar/customScrollBar';
import ModalBox from 'components/modalBox/modalBox';
import { ProductsInformation } from '../../ProductsInformation/ProductsInformation';
import { LegalInfoByCountry } from '../../LegalInfoByCountry/LegalInfoByCountry';
import { EXPAND_DOCUMENT_LEGAL_INFO_BY_COUNTRY } from './constants';

const { LEGAL_INFO, LEGAL_INFO_BY_COUNTRY } = EXPAND_DOCUMENT_LEGAL_INFO_BY_COUNTRY;

export const ExpandDocument = ({ productsInfo }) => {
    return (
        <ModalBox
            bsSize="large"
            className="icons icons--icon-expand"
            textButton=""
            width={800}
            textButtonClose={<FormattedText value="button-exitModal" />}
            modalLogo={<i className="icons icons--icon-openbank-logo" />}
        >
            <div className="legal-info__doc-block-modal">
                <CustomScrollBar width="100%" autoHeightMin={495}>
                    <div>
                        <LegalInfoByCountry
                            legalInfo={LEGAL_INFO.GDPR}
                            legalInfoByCountry={LEGAL_INFO_BY_COUNTRY.GDPR}
                        />
                        <ProductsInformation productsInfo={productsInfo} />
                        <LegalInfoByCountry
                            legalInfo={LEGAL_INFO.INFO}
                            legalInfoByCountry={LEGAL_INFO_BY_COUNTRY.INFO}
                        />
                    </div>
                </CustomScrollBar>
            </div>
        </ModalBox>
    );
};
